'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function noop() {}
var defaultProps = exports.defaultProps = {
    prefixCls: 'am-search',
    placeholder: '',
    onSubmit: noop,
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    onClear: noop,
    showCancelButton: false,
    disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/search-bar/PropsType.js
// module id = 460
// module chunks = 0